export const LoginFocusAction = {
  none: 'none',
  exitAnonymousTrial: 'exitAnonymousTrial',
  redirectAuthenticatedSession: 'redirectAuthenticatedSession',
} as const;

export type LoginFocusActionType = (typeof LoginFocusAction)[keyof typeof LoginFocusAction];

export const getLoginFocusAction = ({
  regainedFocus,
  isAnonymous,
  isAuthenticated,
}: {
  regainedFocus: boolean;
  isAnonymous: boolean;
  isAuthenticated: boolean;
}): LoginFocusActionType => {
  if (!regainedFocus || (!isAnonymous && !isAuthenticated)) {
    return LoginFocusAction.none;
  }

  if (isAnonymous) {
    return LoginFocusAction.exitAnonymousTrial;
  }

  return LoginFocusAction.redirectAuthenticatedSession;
};
